"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_avatar_1 = __importStar(require("react-avatar"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const Config_1 = __importDefault(require("utils/Config"));
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
require("./Avatar.scss");
const TooltipPortal_1 = __importDefault(require("./Tooltips/TooltipPortal"));
const defaultRandomColors = [
    'var(--base-600)',
    'var(--r-600)',
    'var(--y-600)',
    'var(--b-600)',
    'var(--g-600)',
    'var(--n-600)'
];
const Avatar = ({ src = Config_1.default.asset.general.userIcon, name = '', size = 36, className = '', round = true, style = {}, dataCy = 'image-initial-name', onClick, maxInitials = 2, value = '', color = '', disabled = false, isGroup = false, alt = '', textSizeRatio = 2, wrapperClassName = '', usePortal = '', withTooltip = true }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const [errorImage, setErrorImage] = (0, react_1.useState)(false);
    const avatarSize = (size) => {
        switch (size) {
            case 'small':
                return 16;
            case 'medium':
                return 24;
            case 'large':
                return 32;
            case 'xLarge':
                return 40;
            default:
                break;
        }
    };
    const checkSize = typeof size === 'number' ? size : avatarSize(size);
    const checkImage = (src, value) => {
        if (isGroup)
            return Config_1.default.asset.createObjective.iconOwnerGroup;
        if (value)
            return;
        return src;
    };
    let toolTipText = name;
    if (value) {
        toolTipText = value.includes('+') ? 'View Others' : value;
    }
    const setPortal = (e) => {
        setIsTooltipShown(true);
        setPortalData({
            name: name,
            left: e.clientX - 35 + 'px',
            top: e.clientY + 20 + 'px'
        });
    };
    return (react_1.default.createElement("div", { className: `wrapper-avatar ${disabled || ''} ${wrapperClassName || ''}`, "data-cy": dataCy, onMouseEnter: (e) => usePortal && setPortal(e), onMouseLeave: () => setIsTooltipShown(false) },
        react_1.default.createElement(react_avatar_1.ConfigProvider, { colors: defaultRandomColors }, src && !errorImage ? (react_1.default.createElement(AWSImage_1.default, { className: `${className} rounded-full object-cover ${disabled ? 'cursor-default' : 'cursor-pointer'}`, src: checkImage(src, value), onClick: onClick, style: {
                ...style,
                width: `${checkSize}px`,
                height: `${checkSize}px`,
                maxWidth: `${checkSize}px`,
                maxHeight: `${checkSize}px`
            }, alt: alt, onError: () => {
                setErrorImage(true);
            } })) : (react_1.default.createElement(react_avatar_1.default, { src: checkImage(src, value), name: name, size: checkSize?.toString(), className: `${className} ${disabled ? 'cursor-default' : 'cursor-pointer'}`, round: round ? round : '4px', style: style, onClick: onClick, maxInitials: maxInitials, value: value, color: disabled ? 'var(--n-400)' : color, alt: alt, textSizeRatio: textSizeRatio, 
            // @ts-ignore
            title: false }))),
        (name !== '' || value !== '') && withTooltip ? (!disabled && usePortal ? (!(0, isEmpty_1.default)(portalData) && (react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: usePortal }))) : (react_1.default.createElement("div", { className: "tooltip-avatar whitespace-nowrap" }, toolTipText))) : ('')));
};
exports.default = Avatar;
